import { App } from './app/app';

new App( window.spauto_settings );
